var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "server-clock", attrs: { outlined: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "py-3" },
        [
          _c(
            "v-row",
            { attrs: { align: "center", "no-gutters": "" } },
            [
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center mb-2 mb-sm-0",
                  attrs: { cols: "12", sm: "auto" },
                },
                [
                  _c(
                    "v-icon",
                    { staticClass: "mr-2", attrs: { color: _vm.iconColor } },
                    [_vm._v("mdi-clock-outline")]
                  ),
                  _c(
                    "span",
                    { staticClass: "text-subtitle-1 font-weight-medium" },
                    [_vm._v("Relógio")]
                  ),
                ],
                1
              ),
              _c("v-spacer", { staticClass: "d-none d-sm-flex" }),
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "auto" } },
                [
                  _c(
                    "v-row",
                    {
                      class: {
                        "justify-space-between": _vm.$vuetify.breakpoint.xsOnly,
                      },
                      attrs: { "no-gutters": "", align: "center" },
                    },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mr-4 mr-sm-6",
                          attrs: { cols: "auto" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [_vm._v("Data:")]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-body-2 font-weight-medium" },
                            [_vm._v(_vm._s(_vm.clockDate))]
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mr-4 mr-sm-6",
                          attrs: { cols: "auto" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [_vm._v("Hora:")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-body-2 font-weight-medium clock-time",
                            },
                            [_vm._v(_vm._s(_vm.clockTime))]
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "mr-4 mr-sm-6",
                          attrs: { cols: "auto" },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [_vm._v("Fuso:")]
                          ),
                          _c(
                            "div",
                            { staticClass: "text-body-2 font-weight-medium" },
                            [_vm._v(_vm._s(_vm.clockTimezone))]
                          ),
                        ]
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "auto" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "text-caption grey--text text--darken-1",
                            },
                            [_vm._v("Status:")]
                          ),
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: _vm.statusColor,
                                "text-color": _vm.statusTextColor,
                                "x-small": "",
                                label: "",
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.clockStatusLabel) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }